import React, {FC, useEffect, useRef, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useNavigate, useParams} from 'react-router'
import {Visit} from 'entities/activity'
import {clearProfile, clearStateGallery, GetUserInfo, profileMediaModel, setProfile, useProfile, useProfileMediaIsLoaded} from 'entities/profile'
import {useUser} from 'entities/user'
import {Interests} from 'features/interests'
import {scrollTo} from 'shared/lib/scroll-to'
import {MyMedia} from '../myMedia'
import {ProfileAboutMe} from '../profileAboutMe'
import {ProfileBanner} from '../profileBanner'
import {ProfileChatNow} from '../profileChatNow'
import {ProfileMedia} from '../profileMedia'
import {ProfileSummary} from '../profileSummary'
import {SimilarProfiles} from '../similarProfiles'
import styles from './styles.module.scss'

export const Profile: FC<{
  wrapperRef?: React.MutableRefObject<HTMLDivElement | null>,
  className?: string
}> = ({wrapperRef, className}) => {
  const dispatch = useDispatch()
  const {id: idUser} = useParams()
  const user = useUser()
  const isClient = !!idUser
  const profile = useProfile()
  const {interests} = isClient ? profile : user.profile
  const ref = useRef<HTMLDivElement | null>(null)
  const navigate = useNavigate()
  const mediaIsMounted = useProfileMediaIsLoaded()
  const [currentUserId, setCurrentUserId] = useState(idUser)

  useEffect(() => {
    scrollTo(ref)

    if (!idUser) return
    setCurrentUserId(idUser)
    dispatch(clearStateGallery())

    GetUserInfo(idUser)
      .then(({data}) => dispatch(setProfile(data)))
      .catch(error => {
        console.error(error)
        if (error.status === 404) navigate('/myProfile')
      })

    Visit(idUser).catch(console.error)

    return () => {
      dispatch(clearProfile())
      dispatch(profileMediaModel.actions.setIsMediaLoaded(false))
    }
  }, [idUser])


  return (
    <div className={`${styles.profileWrapper} ${className || ''}`} ref={ref}>
      <div className={styles.profile}>
        <ProfileBanner />
        <ProfileSummary />
        <ProfileAboutMe />
        {interests.length
          ? <div className={styles.interests}>
            <Interests data={interests} />
          </div>
          : null}
        {idUser ? <ProfileChatNow /> : null}
      </div>
      {wrapperRef && idUser ? <ProfileMedia wrapperRef={wrapperRef} /> : wrapperRef &&
        <MyMedia wrapperRef={wrapperRef} />}
      {idUser && currentUserId === idUser && mediaIsMounted ? <SimilarProfiles /> : null}
      <div className={styles.bottom}></div>
    </div>
  )
}